<!--<h2 mat-dialog-title>--><!--Scheduled Report Builder--><!--</h2>-->

<mat-dialog-content>
    <div
        class="grid grid-2"
        *ngIf="existingSchedules && existingSchedules.length != 0; else noExistingSchedules"
    >
        <h2 class="g-card-title" style="width: 90%">New Schedule: {{ report.reportName }}</h2>

        <mat-form-field appearance="outline" style="width: 90%">
            <mat-label>Saved Schedules</mat-label>
            <mat-select [(ngModel)]="selectedSchedule">
                <mat-option
                    *ngFor="let schedule of existingSchedules"
                    [value]="schedule.userScheduleReportKey"
                    (click)="selectExisting(schedule)"
                >
                    {{ schedule.scheduleName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <ng-template #noExistingSchedules>
        <h2 class="g-card-title">{{ report.reportName }}</h2>
    </ng-template>

    <main-filters (filtersOutput)="applyNewFilters()" [readonly]="true"></main-filters>

    <display-options
        (displayOptionsOutput)="applyDisplayOptions($event)"
        [optionalSummaryList]="report.optionalSummaryList"
        [showEditButton]="false"
        [extraParameters]="report.routerParams"
        [displayOptionsToReset]="null"
    >
    </display-options>

    <table>
        <!--<tr>
            <td><span class="g-text-title">Name</span></td>
            <td>
                <mat-form-field class="example-form-field" appearance="outline">-->
        <!--<mat-label>Scheduled Report Name</mat-label>-->
        <!--<input matInput type="text" [(ngModel)]="scheduleValues.scheduleName" />
                </mat-form-field>
            </td>
        </tr>-->

        <tr>
            <td><span class="g-text-title">Frequency</span></td>
            <td>
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="scheduleValues.when">
                        <mat-option
                            *ngFor="let option of scheduleOptions.when"
                            [value]="option.value"
                        >
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>

        <tr *ngIf="scheduleValues.when == 2">
            <td><span class="g-text-title">Day</span></td>
            <td>
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="scheduleValues.day">
                        <mat-option
                            *ngFor="let option of scheduleOptions.day"
                            [value]="option.value"
                        >
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>

        <tr *ngIf="scheduleValues.when == 3">
            <td></td>
            <td>
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="scheduleValues.monthly">
                        <mat-option
                            *ngFor="let option of scheduleOptions.monthly"
                            [value]="option.value"
                        >
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>

        <tr>
            <td><span class="g-text-title">Time</span></td>
            <td>
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="scheduleValues.hour">
                        <mat-option
                            *ngFor="let option of scheduleOptions.hour"
                            [value]="option.value"
                        >
                            {{ option.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>
    </table>

    <p class="g-text-secondary" *ngIf="scheduleValues && scheduleOptions" style="padding-top: 20px">
        <span><i class="far fa-clock"></i> &nbsp; Report will be created </span>
        <span *ngIf="scheduleValues.when == 1"
            >daily at {{ scheduleOptions.hour[scheduleValues.hour].name }}.</span
        >
        <span *ngIf="scheduleValues.when == 2">
            weekly on {{ scheduleOptions.day[scheduleValues.day].name }} at
            {{ scheduleOptions.hour[scheduleValues.hour].name }}.
        </span>
        <span *ngIf="scheduleValues.when == 3">
            on the {{ scheduleValues.monthly }} day each month at
            {{ scheduleOptions.hour[scheduleValues.hour].name }}.
        </span>
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close mat-stroked-button>Cancel</button>
    <button mat-button cdkFocusInitial (click)="create()" mat-stroked-button>
        Create Schedule
    </button>
</mat-dialog-actions>
